var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai", staticStyle: { background: "#2562af" } },
    [
      _c(
        "div",
        { staticStyle: { background: "#2562af !important", padding: "10px" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { margin: "0 !important" },
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.goback()
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "white--text",
                  staticStyle: { "font-size": "24px" }
                },
                [_vm._v("chevron_left")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "white",
                "font-weight": "800",
                "margin-left": "25vw"
              }
            },
            [_vm._v("สร้างกลุ่ม")]
          ),
          _vm._v(" "),
          _vm.state == "second"
            ? _c(
                "span",
                {
                  class: "okBTN",
                  on: {
                    click: function($event) {
                      return _vm.skipuploadPic()
                    }
                  }
                },
                [_vm._v("ข้าม")]
              )
            : _c(
                "span",
                {
                  class: _vm.checkEnabledCreateGroup() ? "okBTN" : "okBTNFalse",
                  on: {
                    click: function($event) {
                      return _vm.createGroup()
                    }
                  }
                },
                [_vm._v("ยืนยัน")]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            padding: "10px",
            cursor: "pointer",
            background: "#fafafa"
          }
        },
        [
          _vm.state == "second"
            ? _c(
                "div",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "image-upload" },
                    [
                      _c("v-img", {
                        staticClass:
                          "grey lighten-2 imageProfile alligator-turtle",
                        on: { click: _vm.uppic }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "SettingImgBtn",
                          attrs: { for: "file-input" }
                        },
                        [_vm._v("\n    เพิ่มรูป\n  ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          id: "file-input",
                          type: "file",
                          accept: "image/*"
                        },
                        on: { change: _vm.previewImageprofiles }
                      })
                    ],
                    1
                  )
                ]
              )
            : _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: {
                        xs12: "",
                        xl12: "",
                        lg12: "",
                        md12: "",
                        sm12: ""
                      }
                    },
                    [
                      _c("p", { staticClass: "colorHeader" }, [
                        _vm._v("ชื่อกลุ่ม")
                      ]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          placeholder: "ตั้งชื่อกลุ่ม",
                          counter: "40",
                          height: "35"
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchUser()
                          }
                        },
                        model: {
                          value: _vm.nameGroup,
                          callback: function($$v) {
                            _vm.nameGroup = $$v
                          },
                          expression: "nameGroup"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "margin-bottom": "5px !important" },
                      attrs: {
                        xs12: "",
                        xl12: "",
                        lg12: "",
                        md12: "",
                        sm12: ""
                      }
                    },
                    [
                      _vm.selectedMember.length
                        ? _c("p", { staticClass: "colorHeader" }, [
                            _vm._v("สมาชิก")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "overflow-x": "scroll",
                            "white-space": "nowrap"
                          }
                        },
                        _vm._l(_vm.selectedMember, function(v, index) {
                          return _c(
                            "v-avatar",
                            {
                              staticStyle: { "margin-right": "5px" },
                              attrs: { size: "40", color: "#2562af" },
                              on: {
                                click: function($event) {
                                  return _vm.detailAccount(v)
                                }
                              }
                            },
                            [
                              v.profile_picture
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.backend + v.profile_picture
                                    }
                                  })
                                : _c(
                                    "span",
                                    { staticClass: "headline white--text" },
                                    [
                                      _vm._v(
                                        "\n      " +
                                          _vm._s(
                                            v["display_name"].length >= 2
                                              ? v["display_name"].charAt(0) +
                                                  v["display_name"].charAt(1)
                                              : v["display_name"].charAt(0)
                                          )
                                      )
                                    ]
                                  )
                            ]
                          )
                        }),
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        xl12: "",
                        lg12: "",
                        md12: "",
                        sm12: ""
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          placeholder: "ค้นหาเพื่อน",
                          "prepend-inner-icon": "fas fa-search",
                          "hide-details": "",
                          height: "35"
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchUser()
                          }
                        },
                        model: {
                          value: _vm.searchText,
                          callback: function($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        xl12: "",
                        lg12: "",
                        md12: "",
                        sm12: ""
                      }
                    },
                    [
                      _vm.stateSearch
                        ? _c(
                            "div",
                            [
                              _vm.listUser.length > 0
                                ? _c(
                                    "v-list",
                                    {
                                      staticStyle: {
                                        height: "40vh",
                                        overflow: "scroll",
                                        "margin-top": "10px"
                                      },
                                      attrs: { "two-line": "" }
                                    },
                                    [
                                      _vm._l(_vm.listUser, function(
                                        item,
                                        index
                                      ) {
                                        return [
                                          _c(
                                            "v-list-tile",
                                            {
                                              attrs: { avatar: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleSelectMember(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                {
                                                  attrs: {
                                                    color: "#2562af",
                                                    size: "40"
                                                  }
                                                },
                                                [
                                                  !item.profile_picture
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "white--text headline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n            " +
                                                              _vm._s(
                                                                item[
                                                                  "display_name"
                                                                ].length >= 2
                                                                  ? item[
                                                                      "display_name"
                                                                    ].charAt(
                                                                      0
                                                                    ) +
                                                                      item[
                                                                        "display_name"
                                                                      ].charAt(
                                                                        1
                                                                      )
                                                                  : item[
                                                                      "display_name"
                                                                    ].charAt(0)
                                                              ) +
                                                              "\n          "
                                                          )
                                                        ]
                                                      )
                                                    : _c("img", {
                                                        attrs: {
                                                          src:
                                                            _vm.backend +
                                                            item.profile_picture
                                                        }
                                                      })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", {
                                                    staticClass: "CSChatThai",
                                                    staticStyle: {
                                                      "font-weight": "600"
                                                    },
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        item["display_name"]
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", {
                                                    staticClass: "CSChatThai",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        item["email"]
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  !_vm.checkMemberIn(item)
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "grey lighten-1"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    radio_button_unchecked\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            color:
                                                              "#00abffcf !important",
                                                            "font-size": "17px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    radio_button_checked\n                  "
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          index != _vm.listUser.length - 1
                                            ? _c("v-divider")
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _vm.searchText.length < 3
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป\n  "
                                      )
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n    ไม่พบเพื่อนที่ต้องการค้นหา\n  "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _c(
                            "p",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "margin-top": "10px"
                              }
                            },
                            [
                              _vm._v(
                                "\n    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ\n  "
                              )
                            ]
                          )
                    ]
                  )
                ],
                1
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1316591b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1316591b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Creategroup.vue
// module id = null
// module chunks = 